import "reflect-metadata";
import type { SystemEnumTypes } from "services/enumService";

const ATTRIBUTES_KEY = Symbol("enum:attributes");

export interface EnumReflectAttributes {
  [key: string]: EnumReflectAttribute;
}

export interface EnumReflectAttribute {
  enumName: SystemEnumTypes;
  sourceAttribute: string;
}

export function getEnumAttributes(target: any): EnumReflectAttributes | undefined {
  return Reflect.getMetadata(ATTRIBUTES_KEY, target);
}

export function getEnumAttribute(target: any, attribute: string): EnumReflectAttribute | undefined {
  const attributes = Reflect.getMetadata(ATTRIBUTES_KEY, target);

  if (attributes) {
    const targetAttribute = Object.keys(attributes).find(key => key === attribute);
    if (targetAttribute) {
      return attributes[targetAttribute];
    }
  }

  return undefined;
}

export function setEnumAttributes(target: any, attributes: any): void {
  Reflect.defineMetadata(ATTRIBUTES_KEY, { ...attributes }, target);
}

export function addEnumAttribute(target: any, property: string, options: any): void {
  let attributes = getEnumAttributes(target);

  if (!attributes) {
    attributes = {};
  }
  attributes[property] = { ...options };

  setEnumAttributes(target, attributes);
}

export function enumValue(enumName: SystemEnumTypes, sourceAttribute: string) {
  return (target: any, propertyName: string, propertyDescriptor?: PropertyDescriptor) => {
    addEnumAttribute(target, propertyName, { enumName, sourceAttribute });
  };
}
